// frontend/src/features/categories/NewCategory.js
import NewCategoryForm from './NewCategoryForm';
import useTitle from '../../hooks/useTitle'; // यदि आपके पास यह hook है

const NewCategory = () => {
    useTitle('Nirakar Satguru: New Category'); // पेज का शीर्षक सेट करें

    const content = <NewCategoryForm />;

    return content;
};

export default NewCategory;